var _path, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgCloud2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 428,
    viewBox: "0 0 550 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M783.519 382.494C736.719 398.471 681.72 370.511 646.188 317.703C634.374 352.666 611.414 379.356 579.435 390.275C535.004 405.422 484.196 386.359 444.715 345.222C434.724 383.946 413.769 412.451 383.247 422.852C328.643 441.475 260.129 396.63 213.329 318.196C202.882 331.579 189.489 341.643 173.454 347.116C114.506 367.217 42.6215 317.755 12.8593 236.649C-16.903 155.543 6.75507 73.4778 65.6721 53.3505C99.2305 41.9122 136.98 53.0133 168.747 79.6768C178.951 42.0678 199.693 14.4447 229.638 4.19949C283.088 -14.0344 349.871 28.5545 396.549 103.902C409.487 78.7431 429.348 59.8348 454.98 51.0681C513.077 31.252 582.108 70.0022 622.439 140.059C633.493 115.47 651.684 96.9251 675.737 88.703C734.685 68.6016 806.57 118.064 836.332 199.17C866.094 280.275 842.436 362.341 783.519 382.468V382.494Z",
    fill: "url(#paint0_linear_2701_1005)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2701_1005",
    x1: 160.187,
    y1: -339.655,
    x2: 324.605,
    y2: 570.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19286,
    stopColor: "#B5E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836266,
    stopColor: "#E4F3FF",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud2);
export default __webpack_public_path__ + "static/media/cloud_2.adf31437bb7f9c48b5531acdc17d8c80.svg";
export { ForwardRef as ReactComponent };